import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AcessoComponent } from './acesso.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule } from '@po-ui/ng-templates';
import { AcessoEditComponent } from './acesso-edit/acesso-edit.component';



@NgModule({
  declarations: [AcessoComponent, AcessoEditComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PoModule,
    PoPageDynamicEditModule
  ]
})
export class AcessoModule { }